import { render, staticRenderFns } from "./trash.vue?vue&type=template&id=460991f7&scoped=true&"
var script = {}
import style0 from "./trash.vue?vue&type=style&index=0&id=460991f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460991f7",
  null
  
)

export default component.exports